<template>
  <v-card class="pa-10" light outlined>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-icon color="#312860" large>{{ (alreadyVotedForNominee)? 'fa-rocket' : 'fa-check-to-slot' }}</v-icon>
      </v-row>
      <v-row align="center" justify="center" class="my-5">
        <h3 v-if="!alreadyVotedForNominee">Vota por {{ nominee.name }}</h3>
        <h3 v-else>¡Votaste por {{ nominee.name }}!</h3>
      </v-row>
      <v-row align="center" justify="center">
        <!-- When want to vote !-->
        <v-form v-model="valid" v-if="!alreadyVotedForNominee">
          <p class="text-center">Escribe tu correo{{ (verificationRequired)? ' y código': '' }} para votar por tu favorito</p>
          <v-text-field color="#312860" v-model="voterEmail" label="Tu correo" placeholder="Ej. trader@gmail.com" :rules="emailRules" outlined/>
          <v-text-field v-if="verificationRequired" color="#312860" v-model="verificationKey" label="Tu código verificación" placeholder="Ej. 010101" :rules="keyRules" outlined/>
          <v-btn :disabled="!valid" class="submit-button" :loading="loadingVote" @click="voteForNominee">Votar Ahora »</v-btn>
          <v-btn style="width: 100%" class="mt-3" @click="close">Cerrar</v-btn>
          <p class="text-center mt-5" style="color: #868686">
            Al votar estas aceptando nuestros <a href="https://swiset.com/terms-and-conditions/" target="_blank">términos y condiciones</a>
          </p>
        </v-form>

        <!-- When already voted !-->
        <v-form v-else>
          <p class="text-center">Eres uno de los {{ nomineeTotalVotes }} que depositó su confianza.</p>
          <v-btn style="width: 100%;" class="my-3" @click="goToAwardCategories">Vota por más categorías</v-btn>
          <v-btn style="width: 100%" @click="close">Cerrar</v-btn>
          <v-divider v-if="!hasSwisetAccount" class="my-5"/>
          <p v-if="!hasSwisetAccount" class="text-center">Potencia tu trading con Swiset.<br>¡Crea tu cuenta! Es gratis</p>
          <v-btn v-if="!hasSwisetAccount" class="submit-button" @click="goToRegisterToSwiset">Crear Cuenta de Swiset »</v-btn>
        </v-form>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import Repository from "@/repositories/award";

export default {
  name: "PopupVote",
  props: {
    nominee: Object,
  },
  data() {
    return {
      alreadyVotedForNominee: false,
      hasSwisetAccount: false,
      verificationRequired: false,
      nomineeTotalVotes: 0,

      loadingVote: false,
      valid: false,
      voterEmail: '',
      verificationKey: '',
      emailRules: [
        e => !!e || 'Es obligatorio',
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || 'Correo inválido',
      ],
      keyRules: [
        k => !!k || 'Es obligatorio',
      ],
    };
  },
  methods: {
    voteForNominee() {
      this.loadingVote = true;
      let votingData = {
        awardNomineeId: this.nominee.id,
        voterEmail: this.voterEmail.toLowerCase().trim(),
        verificationKey: this.verificationKey.trim()
      };

      Repository.voteForNominee(votingData).then((response) => {
        if(response.status < 400) {
          this.loadingVote = false;
          let votingResponse = response.data;
          if(votingResponse.voteStatus === -1) {
            this.verificationRequired = true;
            alert('Antes de votar necesitamos validar tu correo.\nRevisa tu correo.');
          }
          else if(votingResponse.voteStatus === -2)
            alert('Ya votaste con este correo por un participante de la categoría.\nNo es válido.');
          else {
            this.alreadyVotedForNominee = votingResponse.voteStatus === 1;
            this.hasSwisetAccount = votingResponse.hasSwiset;
            this.nomineeTotalVotes = votingResponse.totalVotes;
            this.verificationRequired = false;
          }
        }
      })
    },
    goToRegisterToSwiset() {
      this.$router.push('/');
    },
    goToAwardCategories() {
      this.$router.push('/vote/award-categories');
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.submit-button  {
  background-color: #312860 !important;
  color: #00F784 !important;
  width: 100%;
}
</style>
